import { render, staticRenderFns } from "./email-verification-2.vue?vue&type=template&id=2131f11d&scoped=true&"
import script from "./email-verification-2.vue?vue&type=script&lang=js&"
export * from "./email-verification-2.vue?vue&type=script&lang=js&"
import style0 from "./email-verification-2.vue?vue&type=style&index=0&id=2131f11d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2131f11d",
  null
  
)

export default component.exports